import React from "react";
import { useLanguage } from "../../../i18n/LanguageContext";
import { SanityStepper } from "../../../model/common";
import Text from "../../Text/Text";
import { StepData, getNextStep, getStepData } from "../stepper";
import StepperButton from "../StepperButton/StepperButton";
import styles from "./StepperBar.module.scss";
import { internalLinkUrl } from "../../InternalLink/InternalLink";
import { getExternalTo } from "../../ExternalLink/ExternalLink";
import { usePathname } from "../../../utils/usePathname";

interface StepperBarProps {
  node: SanityStepper;
}

const StepperBar = ({
  node: { stepperReference, text, buttonText, internalLink, externalLink }
}: StepperBarProps) => {
  const pathname = usePathname();
  const language = useLanguage();
  const nextStep: StepData = stepperReference
    ? getNextStep(
        getStepData(stepperReference.pages, pathname, language),
        stepperReference.onward,
        language,
        buttonText
      )
    : {
        to: internalLink
          ? internalLinkUrl(
              internalLink.reference,
              internalLink.query,
              internalLink.fragment,
              language
            )
          : getExternalTo(externalLink, language) || "",
        stepNumber: null,
        title: buttonText ?? "",
        active: true,
        visited: false,
        _id: "",
        _type: ""
      };
  return (
    <div className={styles.root}>
      {nextStep.to && nextStep.title && (
        <div className={styles.nextStep}>
          <Text variant="toolbarDefaultBold">{text}</Text>
          <StepperButton className={styles.stepperButton} {...nextStep} bold />
        </div>
      )}
    </div>
  );
};

export default StepperBar;
